import DOMPurify from "dompurify"

export function sanitize(dangerousHTML = "") {
  return DOMPurify.sanitize(dangerousHTML, { ALLOWED_TAGS: ["p", "a"] })
}
